import { translationEn } from './en'
import { translationNb } from './nb'
import { translationNn } from './nn'

export default {
  translationNn,
  translationNb,
  translationEn
}
